export * from './RuntimeBlocks'
export * from './ConsensusBlocks'
export enum BlocksTableType {
  Mobile,
  DesktopLite,
  Desktop,
}
